"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * A hook that returns a debounced version of the callback function
 *
 * @param callback The callback function to debounce
 * @param delay The delay in milliseconds (defaults to 300ms)
 * @param dependencies The dependencies array for the useCallback hook
 * @returns A debounced callback function
 */
function useDebouncedCallback(callback, delay = 300, dependencies = []) {
    // Use a ref to store the timeout ID
    const timeoutRef = (0, react_1.useRef)(null);
    // Use the useCallback hook to memorize the returned function
    return (0, react_1.useCallback)((...args) => {
        // If there's an existing timeout, clear it
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        // Set a new timeout
        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    }, [...dependencies, delay]);
}
exports.default = useDebouncedCallback;
